/** Code for the Footer of the webpage. */
const FooterComponent = () => {
  return (
    <div>
        <footer className="footer">
            <span>Thank you for using our service!</span>
        </footer>
    </div>
  )
}

export default FooterComponent